import { GoogleMaps, GoogleMap, GoogleMapsEvent, GoogleMapOptions, Spherical } from '@ionic-native/google-maps';
import { Component, Input } from '@angular/core';
import { NavController, NavParams, Platform, AlertController, PopoverController } from 'ionic-angular';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { LocationsProvider } from '../../providers/locations/locations';
import { MailProvider } from '../../providers/mail/mail';
import moment from 'moment';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { CoSecurityPopoverComponent } from '../co-security-popover/co-security-popover';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { CoCountdownComponent } from '../co-countdown/co-countdown';
/**
 * Generated class for the CoRoamSecurityComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-roam-security',
  templateUrl: 'co-roam-security.html',
  providers: [
    Spherical
  ]
})

export class CoRoamSecurityComponent {
  @Input() buttons;
  @Input() messages;
  @Input() departments;
  @Input() form;
  clientKeyword: string;
  hideForm: boolean;
  selectedGroup: number;

  // Message declarations
  customMessage: string;
  messageText: any;
  selectedMessage: number;
  securityMessages: Array<any>;
  hideMessageBox: boolean;

  // Map declarations
  closestBranch: any;
  currentLocation: any;
  selectedLocation: number;
  locations: Array<any> = [];
  hideMap: boolean;
  map: GoogleMap;
  mapsUrl: string;
  showLocationSelector: boolean;

  //Maintenance/Security
  chosenLocation: any;
  chosenDepartment: any;
  chosenMessage: any = { name: '', message: '' };
  maintenanceImages: Array<string> = [];

  constructor(public client: ClientDetailsProvider, public navCtrl: NavController, public navParams: NavParams, private mail: MailProvider, private platform: Platform, private locationsProvider: LocationsProvider, private alert: AlertController, private toast: ToastAlertsProvider, private popoverCtrl: PopoverController, private camera: Camera, private alertCtrl: AlertController) {
    this.customMessage = '';
    this.hideMessageBox = true;
    this.hideForm = true;
    this.hideMap = true;
    let lintWindow: any = window; //lint was breaking shit
    if (lintWindow.cordova && lintWindow.cordova.plugins && lintWindow.cordova.plugins.Keyboard) {
      lintWindow.cordova.plugins.Keyboard.disableScroll(false);
    }
    window.addEventListener('native.keyboardhide', this.scrollWindow);
  }

  scrollWindow() {
    window.scroll(0, window.scrollY);
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    let lintWindow: any = window; //lint was breaking shit
    if (lintWindow.cordova && lintWindow.cordova.plugins && lintWindow.cordova.plugins.Keyboard) {
      lintWindow.cordova.plugins.Keyboard.disableScroll(true);
    }
    window.removeEventListener('native.keyboardhide', this.scrollWindow);
  }

  async getLocation() {

    this.currentLocation = {
      lat: 39.953932,
      lng: -75.158877
    };
    // Get branch info
    this.locationsProvider.getUserLocation().then((res) => {
      this.currentLocation = res;
      this.getLocations();
    });
    // Get current location info
    /*
    this.geo.getCurrentPosition().then(async (resp) => {
      this.currentLocation = {
        lat: resp.coords.latitude,
        lng: resp.coords.longitude
      };
      //this.mapsUrl = 'https://www.google.com/maps/search/?api=1&query=' + this.currentLocation.lat + ',' + this.currentLocation.lng;
      //this.closestBranch = this.locationsProvider.findClosestBranch(this.currentLocation);
      console.log('cl', this.currentLocation);
      return;
    }).catch((error) => {
      console.log('Error getting location:', error);
      this.showLocationSelector = true;
      return;
    });
    */
  }

  async loadMap() {
    if (!this.currentLocation.lat) {
      this.getLocation();
    }

    let mapOptions: GoogleMapOptions = {
      camera: {
        target: {
          lat: this.currentLocation.lat,
          lng: this.currentLocation.lng
        },
        zoom: 18,
        tilt: 30
      }
    };

    this.hideMap = false;
    this.map = GoogleMaps.create('map', mapOptions);
    this.map.one(GoogleMapsEvent.MAP_READY).then(() => {
      this.map.addMarker({
        title: 'Emergency Location',
        icon: 'red',
        animation: 'DROP',
        position: {
          lat: this.currentLocation.lat,
          lng: this.currentLocation.lng
        }
      }).then(marker => {
        marker.on(GoogleMapsEvent.MARKER_CLICK).subscribe(() => {
          alert('clicked!');
        });
      });

      // console.log('Map ready!');
    });
  }

  changeMessage() {
    this.hideMessageBox = false;
    if (this.selectedMessage !== 3) {
      this.messageText = this.securityMessages[this.selectedMessage].message;
    } else {
      this.messageText = '';
    }

    // console.log('mt', this.messageText);
  }

  getLocations() {
    this.locations = [];
    this.locationsProvider.getLocations().then((locations) => {
      locations.forEach((location) => {
        this.locations.push({
          name: location.name,
          id: location.id,
          lat: location.locationLatitude,
          lng: location.locationLongitude
        });
      });
      this.closestBranch = this.locationsProvider.findClosestBranch(this.locations, this.currentLocation);
    }, (err) => {
      this.locations.push({
        name: 'No Locations Available',
        id: -1
      })
    });
  }

  async sendMessage() {
    if (!this.chosenLocation || !this.chosenDepartment || this.chosenMessage.name.length === 0) {
      this.toast.triggerToast('Please fill out the required fields.', 'Error', 'warning', 5000);
      return;
    }
    let time = moment().format("LLLL");
    let emailFailed = false;
    this.chosenDepartment.forEach(department => {
      // console.log(this.chosenMessage, department.contacts);
      department.contacts.forEach(contact => {
        if (contact.type === 'email') {
          // if(this.platform.is('cordova')){
          //   //await this.mail.sendMobileEmail(contacts, 'colin@communico.co', message.subject, message.message);
          //   await this.sms.sendMobileSMS(contacts, message.message);
          //   await this.mail.sendEmailForBrowser(contacts, 'no-reply@mylocallibrary.info', message.name, message.message);
          //   await this.sms.sendSMSForBrowser(contacts, message.message);
          // } else {
          //   await this.mail.sendEmailForBrowser(contacts, 'no-reply@mylocallibrary.info', message.name, message.message);
          //   await this.sms.sendSMSForBrowser(contacts, message.message);
          // }
          // console.log(this.chosenLocation, this.chosenDepartment, this.chosenMessage);
          // let template = `<p>Location: ${this.chosenLocation}</p><p>Department: ${department.name}</p><p>Issue: ${this.chosenMessage.message}</p><img src="${this.maintenanceImages[0]}">`;
          let params = {
            email: contact.data,
            template: 'maintenance_email',
            phone: ''
          }
          let imgHtml = '';
          this.maintenanceImages.forEach((img) => {
            imgHtml += img
          });
          let content = {
            branch: this.chosenLocation.name,
            department: department.name,
            issue: this.chosenMessage.name,
            message: this.chosenMessage.message,
            images: imgHtml
          }
          if (this.form === 'maintenance') {
            this.mail.sendContactRequest(params, content);
          } else if (this.form === 'broadcast') {
            params = {
              email: contact.data,
              template: 'broadcast_email',
              phone: ''
            }
            this.mail.sendContactRequest(params, content);
          }
        }
      });
    });

    if (emailFailed) {
      let alert = this.alert.create({
        title: 'Error',
        subTitle: `Error sending request`,
        cssClass: 'alertButton',
        buttons: ['OK']
      });
      alert.present();
    } else {
      let alert = this.alert.create({
        title: 'Success',
        subTitle: `You maintenance request has been sent!`,
        cssClass: 'alertButton',
        buttons: ['OK']
      });
      if (this.form === 'broadcast') {
        alert = this.alert.create({
          title: 'Success',
          subTitle: `Your message has been sent!`,
          cssClass: 'alertButton',
          buttons: ['OK']
        });
      }
      alert.present();
    }
    // if(!this.closestBranch){
    //   this.getLocation();
    // }
    // message.message += "\nClosest Branch: " + this.closestBranch.name;
    // message.message += "\nSent By: testuser@communico.co";
    // message.message += "\n\nMessage was sent on:" + time;
  };



  async sendEmergencyAlert() {
    // console.log('S.E.A - 911', 'ALERT ALERT ALERT ALERT!');
    // this.loadMap();
    // let contacts = this.distributionGroup[0].contacts;
    let nearestLocation: string = '';
    this.locationsProvider.getUserLocation().then((userLocation) => {
      if (userLocation.lat === '' && userLocation.lng === '') {
        this.toast.triggerToast('Could not determine location, ensure location services are enabled', '', 'warning', 3000);
        return;
      }
      this.locationsProvider.getLocations().then((locations) => {
        // console.log('response', locations);
        let locationsArray: any = locations; //cannot add distance to object
        locationsArray.forEach((location, i) => {
          var radlat1 = Math.PI * userLocation.lat / 180;
          var radlat2 = Math.PI * location.locationLatitude / 180;
          var theta = userLocation.lng - location.locationLongitude;
          var radtheta = Math.PI * theta / 180;
          var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
          dist = Math.acos(dist);
          dist = dist * 180 / Math.PI;
          dist = dist * 60 * 1.1515;
          location = dist.toFixed(3);
        });
        locationsArray.sort(function (a, b) {
          return parseInt(a.distance) - parseInt(b.distance);
        });
        // locationsArray = locationsArray.reverse();
        // console.log(locationsArray);
        nearestLocation = locationsArray[0].name;
        if (nearestLocation.length === 0) {
          this.toast.triggerToast('Could not determine your closest branch, ensure location services are enabled', '', 'warning', 3000);
          return;
        }
        let countdownPopover = this.popoverCtrl.create(CoCountdownComponent, { time: 5, message: 'Message sending in', detail: `Sending to branch: ${nearestLocation}`}, { cssClass: 'place-holds-popover' })
        countdownPopover.present();
        countdownPopover.onDidDismiss((data) => {
          if (data && data.success) {
            let alert = this.alert.create({
              title: 'Success.',
              subTitle: `You have sent an emergency message!`,
              cssClass: 'alertButton',
              buttons: ['OK']
            });

            alert.present();
          } else {
            let alert = this.alert.create({
              title: 'Cancelled.',
              subTitle: `No alert was sent`,
              cssClass: 'alertButton',
              buttons: ['OK']
            });

            alert.present();
          }
        })
      })



    })
    // let message = this.securityMessages[2];
    // let time = moment().format("LLLL");

    // if(contacts.length > 0){
    // Send emails/texts as a single blast
    // Eventually we'll have to get some kind of user information if they are logged in; given that this is roam, they should always be in that state
    // console.log('url', this.mapsUrl);
    // console.log('closest', this.closestBranch);
    // console.log('time', time);
    // console.log('currentPos', this.currentLocation);

    //message.message += "\nLocation: " + this.mapsUrl;
    // message.message += "\nClosest Branch: " + this.closestBranch.name;
    // message.message += "\n\nSent By: testuser@communico.co";
    // message.message += "\nMessage was sent on:" + time;

    //this.sms.sendMobileSMS(contacts, message.message);
    // if(this.platform.is('cordova')){
    //   await this.sms.sendMobileSMS(contacts, message.message);
    //   await this.mail.sendEmailForBrowser(contacts, 'no-reply', message.name, message.message);
    //   await this.sms.sendSMSForBrowser(contacts, message.message);
    // } else {
    //   await this.mail.sendEmailForBrowser(contacts, 'no-reply', message.name, message.message);
    //   await this.sms.sendSMSForBrowser(contacts, message.message);
    // }
    // let time = 5;
    // setInterval(() => {
    //   time--;
    // }, 1000);

    // let countdown = this.alert.create({
    //   title: 'Confirm',
    //   subTitle: `Sending emergency alert in ${time}`,
    //   cssClass: 'alertButton',
    //   buttons: [{
    //     text: 'Cancel',
    //     role: 'cancel',
    //     handler: (data) => {
    //       countdown.dismiss({send: true})
    //     }
    //   }]
    // });

    // countdown.present();


    // }
  }

  showLocationList() {
    this.locationsProvider.getLocations().then((locations) => {
      this.locations = locations;
      let popup = this.popoverCtrl.create(CoSecurityPopoverComponent, { locations: this.locations, chosenLocation: this.chosenLocation }, { cssClass: 'place-holds-popover' });
      popup.present({
        ev: '',
        animate: false
      });
      popup.onDidDismiss((data) => {
        if (data) {
          this.chosenLocation = data.data;
        }
      });
    });
  }

  showDepartmentList() {
    let popup = this.popoverCtrl.create(CoSecurityPopoverComponent, { departments: this.departments, chosenDepartment: this.chosenDepartment }, { cssClass: 'place-holds-popover' });
    popup.present({
      ev: '',
      animate: false
    });
    popup.onDidDismiss((data) => {
      if (data) {
        this.chosenDepartment = data.data;
      }
    });
  }

  generateDepartmentText() {
    let departmentString = '';
    this.chosenDepartment.forEach((department, i) => {
      departmentString += department.name;
      if (i !== this.chosenDepartment.length - 1) {
        departmentString += ', ';
      }
    });
    return departmentString;
  }

  showIssueList() {
    let popup = this.popoverCtrl.create(CoSecurityPopoverComponent, { messages: this.messages, chosenMessage: this.chosenMessage }, { cssClass: 'place-holds-popover' });
    popup.present({
      ev: ''
    });
    popup.onDidDismiss((data) => {
      if (data) {
        this.chosenMessage = data.data;
      }
    });
  }

  getPhoto(takePhoto) {
    if (takePhoto) {
      const options: CameraOptions = {
        quality: 20,
        sourceType: this.camera.PictureSourceType.CAMERA,
        destinationType: this.camera.DestinationType.DATA_URL,
        saveToPhotoAlbum: false,
        correctOrientation: true
      }
      this.camera.getPicture(options).then((imageData) => {
        this.resizeAndAddImage(imageData);
      }, (err) => {
        console.log('error with getting picture',err);
      });
    } else {
      const options: CameraOptions = {
        quality: 20,
        destinationType: this.camera.DestinationType.DATA_URL,
        sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
        saveToPhotoAlbum: false
      }

      this.camera.getPicture(options).then((imageData) => {
        this.resizeAndAddImage(imageData);
      }, (err) => {
        console.log('error with getting picture',err);
      });
    }
  }

  resizeAndAddImage(imageData: string): void {
    // resize to 550px max width/height
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas'),
        ctx = canvas.getContext('2d');
      canvas.width = img.width > img.height ? 550 : 550 * img.width / img.height;
      canvas.height = img.width > img.height ? 550 * img.height / img.width : 550;
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      let resizedImageData = canvas.toDataURL('image/jpeg').replace('file://', '');
      this.maintenanceImages.push(resizedImageData);
    }
    imageData.replace('file://', '');
    img.src = 'data:image/jpeg;base64,' + imageData;
  }

  removeImage(i) {
    let alert = this.alertCtrl.create({
      title: 'Remove image',
      message: 'Are you sure you want to remove this image?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'alertButton',
          handler: () => {
            return;
          }
        },
        {
          text: 'Ok',
          cssClass: 'alertButton',
          handler: () => {
            this.maintenanceImages.splice(i, 1);
          }
        }
      ]
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/components/co-roam-security/co-roam-security.ts